import { memo, useCallback, useMemo, useRef, useState } from "react";

import { type BentoBoxCardProps } from "@root/tablescape/state/bentoBox";
import { formatFullyQualifiedUrl } from "@root/tablescape/utilities";

import { BentoBoxCardView } from "./BentoBoxCard.view";

const BentoBoxCardBase = (props: BentoBoxCardProps) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleToggleVideo = useCallback(() => {
    if (videoRef?.current) {
      if (isVideoPlaying) {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      } else {
        videoRef.current.play();
        setIsVideoPlaying(true);
      }
    }
  }, [isVideoPlaying, setIsVideoPlaying, videoRef]);

  const videoSources = useMemo<
    {
      mimeType?: string;
      url?: string;
    }[]
  >(() => {
    const sources = [];
    if (props.videoWebm) {
      sources.push({ mimeType: "video/webm", url: props.videoWebm });
    }
    if (props.videoMp4) {
      sources.push({ mimeType: "video/mp4", url: props.videoMp4 });
    }
    return sources;
  }, [props.videoWebm, props.videoMp4]);

  return (
    <BentoBoxCardView
      {...props}
      handleToggleVideo={handleToggleVideo}
      {...(props.imageUrl && {
        imageUrl: formatFullyQualifiedUrl(props.imageUrl),
      })}
      isVideoPlaying={isVideoPlaying}
      videoRef={videoRef}
      videoSources={videoSources}
    />
  );
};

export const BentoBoxCard = memo(BentoBoxCardBase);
